import api from './api.js';

class User {
    constructor(){
        this.url_user        = 'Users';
        this.url_update_user = 'Users/Profile';
        this.url_create_user = 'Dealers';
        this.url_pw_forgot   = 'Account/ForgotPassword';
        this.url_pw_reset    = 'Account/ResetPassword';
        this.url_pw_update   = 'Account/ChangePassword';
    }

    create(dealerId, data){
        return api.post(`${this.url_create_user}/${dealerId}/SalesReps`, data);
    }

    update(data){
        return api.put(this.url_update_user, data);
    }

    salesTax(userId){
        return api.get(`${this.url_user}/${userId}/SalesTax`);
    }

    get(){
        return api.get(`${this.url_user}/Profile`);
    }

    updatePassword(data){
        return api.post(this.url_pw_update, data);
    }

    triggerPasswordResetEmail(data){
        return api.post(this.url_pw_forgot, data);
    }

    resetPassword(data){
        return api.post(this.url_pw_reset, data);
    }

    lock(userId){
        return api.put(`${this.url_user}/${userId}/lock`);
    }

    unlock(userId){
        return api.put(`${this.url_user}/${userId}/unlock`);
    }
}

export default new User;
